// extracted by mini-css-extract-plugin
export var bannerHeading = "index-module--bannerHeading--fp2RC";
export var midBannerContainer = "index-module--midBannerContainer--XJAOY";